import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { loginFormBox, mainBox } from './CardLogin.sx';

interface Props {
  children: ReactNode;
}
const CardLogin = ({ children }: Props) => {
  return (
    <Box sx={mainBox}>
      <Box sx={loginFormBox}>{children}</Box>
    </Box>
  );
};

export default CardLogin;
